import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import NoPage from "../common/NoPage";

function PrivateRoute({ children, user, onlySuperUser, onlyAdmin, onlyProductTeam, anyOf }) {
  const location = useLocation();
  const returnUrl = location.pathname + location.search;

  if (!user) {
    return (
      <Navigate to={`/login?returnUrl=${encodeURIComponent(returnUrl)}`} />
    );
  }

  // Allow access if the user holds ANY of the listed roles (OR semantics).
  if (anyOf && anyOf.length > 0) {
    const roleFlags = {
      superUser: user.isSuperUser,
      admin: user.isAdmin,
      productTeam: user.isProductTeam,
    };
    if (!anyOf.some((role) => roleFlags[role])) {
      return <NoPage />;
    }
  }

  if (onlySuperUser && !user.isSuperUser) {
    return <NoPage />;
  }

  // Super users have all permissions including admin access
  if (onlyAdmin && !user.isAdmin && !user.isSuperUser) {
    return <NoPage />;
  }

  if (onlyProductTeam && !user.isProductTeam) {
    return <NoPage />;
  }

  return <>{children}</>;
}

export default PrivateRoute;
